import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONUSES = [{
  title: 'Reiki en 7 Días',
  emoji: '📖'
}, {
  title: 'Mapa de Chakras Aplicado',
  emoji: '🧭'
}, {
  title: 'Manual Anti-Dudas',
  emoji: '❓'
}, {
  title: 'Reiki para Ansiedad y Estrés',
  emoji: '🧘'
}, {
  title: 'Reiki de Bolsillo',
  emoji: '📋'
}, {
  title: 'Diario de Práctica 30 Días',
  emoji: '📓'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5 relative overflow-hidden" data-id="element-44">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-45">
        <div ref={ref1} className={`reveal text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-46">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-47">
            + 6 Bonos Exclusivos
          </h2>
          <p className="text-lg md:text-xl text-[#eab308] font-serif italic mb-8" data-id="element-48">
            Valorados en $27.940 — incluidos gratis
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4" data-id="element-49">
            {BONUSES.map((bonus, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-xl p-4 flex flex-col items-center text-center gap-2" data-id="element-50">
                <span className="text-2xl" data-id="element-51">{bonus.emoji}</span>
                <span className="text-white text-xs sm:text-sm font-semibold leading-snug" data-id="element-52">
                  {bonus.title}
                </span>
              </div>)}
          </div>

          <p className="text-gray-500 text-xs mt-6" data-id="element-53">
            🎁 Todos incluidos sin costo extra con tu compra
          </p>
        </div>
      </div>
    </section>;
}